import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { EmployeeProfileQueryKey } from './queryKey';
export var useGetEmployeeProfiles = function () {
    var intl = useIntl();
    return useQuery([EmployeeProfileQueryKey.EmployeeProfiles], function () { return api.base.get('/api/employeeProfile/Overview').then(function (res) { return res.data; }); }, {
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
